import React, { useContext } from 'react'
import { Col, Button, Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { getQueryParams } from '../../utils/helpers'
import appConfig from '../../app.config'
import { DefaultSpinner } from '../pageBlocks/Spinners'
import httpClient from '../../services/httpClient'
import { appInsights } from '../../appInsights'
import { appRoutes } from '../../constants/routes'
import { appConstants } from '../../constants/appConstants'
import { IVideoIdAuthInit } from '../../interfaces/i-videoid'
import i18n from '../../i18n'

interface IVideoIdAuthProps {
	id: string
	onError(error: Error | undefined): void
	onSuccess(str: string): void
}

function VideoIdContentBlock({ id, onError }: IVideoIdAuthProps) {
	const { t } = useTranslation()
	const [isWaiting, setIsWaiting] = React.useState(false)

	const { SigningRequestId } = getQueryParams()
	const signingRequestId = id || SigningRequestId

	if (!signingRequestId) {
		// if we don't have the signingRequestId, redirect to /sign start page to ask for it (this happens if the user has authenticated but then logged out again before signing)
		window.location.replace(window.location.origin + appRoutes.signRoot)
	}

	async function tryVideoIdAuth() {
		onError(undefined)

		try {
			if (!signingRequestId) {
				// if we don't have the signingRequestId, redirect to /sign start page to ask for it (this happens if the user has authenticated but then logged out again before signing)
				window.location.replace(window.location.origin + appRoutes.sign)
				return
			}
			localStorage.setItem(
				appConstants.signingRequestId,
				signingRequestId,
			)

			setIsWaiting(true)

			// Request Sign API to init VideoId in Id Server (need to go via Sign API as that's where the request data needed for the video init is)
			const videoIdLink = await httpClient.videoIdAuthInit({
				signingRequestId: signingRequestId,
				market: appConfig.country.toUpperCase(),
				redirectUrl: window.location.origin + appRoutes.callback, // the one we get to after fininshing videoid in authui
				failUrl: window.location.origin + appRoutes.error,
				cancelUrl: window.location.origin + appRoutes.login,
			} as IVideoIdAuthInit)

			setIsWaiting(false)

			// Redirect to auth ui
			window.location.replace(videoIdLink + '?lang=' + i18n.language)
		} catch (exception) {
			appInsights.trackException({ exception: exception as Error })
			onError(new Error(t('VideoIdInitError')))
		}
		setIsWaiting(false)
	}

	if (isWaiting) {
		return (
			<Container className="VideoId">
				<Col xs={12}>
					<DefaultSpinner />
				</Col>
			</Container>
		)
	}

	return (
		<Container className="VideoId">
			<Col xs={12} className="videoIdHelpText">
				<p>{t('VideoIdInfoText')}</p>
			</Col>
			<Col xs={12}>
				<Button onClick={tryVideoIdAuth} variant="primary">
					{t('Proceed')}
				</Button>
			</Col>
		</Container>
	)
}

export default VideoIdContentBlock
